module.exports = __webpack_public_path__ + "static/presenting-4-7c3d57ec62c47c94b83e339be4f65515.jpg";